import React, { useEffect, useState, useCallback, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import { Spinner } from "../../Spinner";
import { useUnidades } from "../../../hooks/test/useUnidades";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { formatDate } from "../../../helpers/formatDate";
import { useReactToPrint } from 'react-to-print';
export const HistoricoEventosViaje = ({ idViaje, mostrarModal, onAction, isLoaded }) => {
    useEffect(() => {
        handleShow();
    }, [mostrarModal]);

    useEffect(() => {
        if (!idViaje) return;
        getInfo(idViaje);
    }, [idViaje]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [loading, setLoading] = useState(false);
    const [bitacora, setBitacora] = useState([]);
    const [numUnidad, setNumUnidad] = useState([]);
    const containerStyle = { width: 'auto', height: '150px' };
    const [map, setMap] = useState(null);
    // const [center, setCenter] = useState();
    const demoFancyMapStyles = require("../../../components/jsonstyleMap/demoFancyMapStyles.json");

    const {
        getBitacoraViaje,
    } = useUnidades();

    const getInfo = async (viaje_id) => {
        setLoading(true);
        let resp = await getBitacoraViaje(viaje_id);
        if (resp.ok) {
            setBitacora([...resp.bitacora.reverse()]);
            setNumUnidad(resp.bitacora[0].viaje.unidad.unidad_numero);
            setLoading(false);
        } else {
            setLoading(false);
        }
    }

    // const onLoad = useCallback(function callback(map) {
    //     // This is just an example of getting and using the map instance!!! don't just blindly copy!
    //     const bounds = new window.google.maps.LatLngBounds(center);
    //     map.fitBounds(bounds);
    //     setMap(map)
    // }, []);

    const onUnmount = useCallback(function callback(map) {
        setMap(null)
    }, []);

    const viewHistory = () => {

        return (
            bitacora.map((registro, index) => {
                return (
                    <>
                        <div className="card mb-3" key={index} ref={componentRef}>
                            <div className="row g-0">
                                <div className="col-md-4">
                                    <div style={{ height: "150px", width: "auto" }}>
                                        {
                                            isLoaded ? (
                                                <GoogleMap
                                                    mapContainerStyle={containerStyle}
                                                    center={{
                                                        lat: registro.latitud ? registro.latitud : 0,
                                                        lng: registro.longuitud ? registro.longuitud : 0
                                                    }}
                                                    zoom={15}
                                                    onUnmount={onUnmount}
                                                    options={{
                                                        styles: [...demoFancyMapStyles],
                                                        clickableIcons: false,
                                                        mapTypeControl: false,
                                                    }}
                                                >
                                                    <Marker
                                                        position={{
                                                            lat: registro.latitud ? registro.latitud : 0,
                                                            lng: registro.longuitud ? registro.longuitud : 0
                                                        }}
                                                    />
                                                    <></>
                                                </GoogleMap>
                                            ) : <></>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <div className="card-body" >
                                        {/* <b className="card-title" style={{fontSize: "13px",  float: "right"}}>
                                            {registro.viaje.unidad.unidad_numero}
                                        </b> */}
                                        <b className="card-title text-muted" style={{ fontSize: "13px", float: "right" }}>
                                            {formatDate(registro.bitacora_fecha_hora)}
                                        </b>
                                        <div className="row">
                                            <div className="col-12 pt-2">
                                                <b>Evento: </b><b className="text-muted">{registro.status.nombre}</b>
                                            </div>
                                            <div className="col-12 pt-2">
                                                <b>Notas: </b><b className="text-muted">{registro.notas}</b>
                                            </div>
                                            <div className="col-12 pt-2">
                                                <b>Coordenadas: </b><b className="text-muted">{registro.latitud} {registro.longuitud}</b>
                                            </div>
                                            <div className="col-12 pt-2">
                                                <p className="card-text">
                                                    <small className="text-muted">Dirección: {registro.direccion}</small>
                                                </p>
                                            </div>
                                        </div>
                                        <p className="card-title text-muted" style={{ fontSize: "13px", float: "right" }}>
                                            <small className="text-muted"> {bitacora.length - index}</small>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                );
            })
        )
    }

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return (
        <>
            {loading && <Spinner />}
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                fullscreen={true}
                keyboard={false}
            >
                <Modal.Header>
                    <h3> HISTÓRICO DE EVENTOS</h3>
                    {/* <button
                        className="btn btn-outline-success"
                        style={{ fontSize: "30px", padding: "0px 7px" }}
                        onClick={() => {
                            handlePrint()
                        }}
                    >
                        <FontAwesomeIcon icon={faFileArrowDown} />
                    </button> */}
                    <h3 style={{ float: "right" }}>{numUnidad}</h3>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        {/* {bitacora ? viewHistory() : ""} */}
                        <div ref={componentRef}>

                            {
                                bitacora.map((registro, index) => {
                                    return (
                                        <>
                                            <div className="card mb-3" key={index} style={{ breakInside: "avoid" }}>
                                                <div className="row g-0">
                                                    <div className="col-md-4">
                                                        <div style={{ height: "150px", width: "auto" }}>
                                                            {
                                                                isLoaded ? (
                                                                    <GoogleMap
                                                                        mapContainerStyle={containerStyle}
                                                                        center={{
                                                                            lat: registro.latitud ? registro.latitud : 0,
                                                                            lng: registro.longuitud ? registro.longuitud : 0
                                                                        }}
                                                                        zoom={15}
                                                                        onUnmount={onUnmount}
                                                                        options={{
                                                                            styles: [...demoFancyMapStyles],
                                                                            clickableIcons: false,
                                                                            mapTypeControl: false,
                                                                        }}
                                                                    >
                                                                        <Marker
                                                                            position={{
                                                                                lat: registro.latitud ? registro.latitud : 0,
                                                                                lng: registro.longuitud ? registro.longuitud : 0
                                                                            }}
                                                                        />
                                                                        <></>
                                                                    </GoogleMap>
                                                                ) : <></>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="card-body" >
                                                            {/* <b className="card-title" style={{fontSize: "13px",  float: "right"}}>
                                                                {registro.viaje.unidad.unidad_numero}
                                                            </b> */}
                                                            <b className="card-title text-muted" style={{ fontSize: "13px", float: "right" }}>
                                                                {formatDate(registro.bitacora_fecha_hora)}
                                                            </b>
                                                            <div className="row">
                                                                <div className="col-12 pt-2">
                                                                    <b>Evento: </b><b className="text-muted">{registro.status.nombre}</b>
                                                                </div>
                                                                <div className="col-12 pt-2">
                                                                    <b>Notas: </b><b className="text-muted">{registro.notas}</b>
                                                                </div>
                                                                <div className="col-12 pt-2">
                                                                    <b>Coordenadas: </b><b className="text-muted">{registro.latitud} {registro.longuitud}</b>
                                                                </div>
                                                                <div className="col-12 pt-2">
                                                                    <p className="card-text">
                                                                        <small className="text-muted">Dirección: {registro.direccion}</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <p className="card-title text-muted" style={{ fontSize: "13px", float: "right" }}>
                                                                <small className="text-muted"> {bitacora.length - index}</small>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    );
                                })
                            }

                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => (handleClose(), onAction())}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}